import React from "react";
import { CommonService } from "@services";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import DynamicHtml from "../CommonComponent/DynamicHtml";

const PatientCardDetails = ({ selectedPlanCardDetails, resultname,channelName }) => {
  selectedPlanCardDetails = CommonService.htmlDecode(selectedPlanCardDetails ?? "");
  return (
    <Card style={{ width: "100%" }} className="norstella-cf-card" part="cfCard" variant="outlined">
      <CardContent className="norstella-cf-patientCardContent">
        <div>
          {selectedPlanCardDetails && selectedPlanCardDetails.trim() !== "" ? (
            <DynamicHtml
              input={selectedPlanCardDetails}
              resultname={resultname}
              className="norstella-cf-planCardDetails"
              part="cfDivselectedPlanCardDetailsText"
              channelName={channelName}
            />
          ) : (
            ""
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default PatientCardDetails;
